/* eslint-disable import/no-anonymous-default-export */
import styled from 'styled-components';

export default {
    tableContainer: styled.div`
        width: 100%;
        overflow-x: auto;
        padding: 20px;
    `,
    tradeoffTable: styled.table`
        border-collapse: collapse;
        width: 100%;
        border: 1px solid #ddd;
    `,
    th: styled.th`
        background-color: #e0b158;
        padding: 10px;
        text-align: center;
        border: 1px solid #ddd;
        width: 140px;
    `,
    att: styled.th`
        background-color: #e0b158;
        padding: 10px;
        text-align: start;
        border: 1px solid #ddd;
        width: 180px;
    `,
    att2: styled.th`
        background-color: #e0b158;
        padding: 10px;
        text-align: start;
        border: 1px solid #ddd;
        width: 320px;
    `,
    field: styled.th`
        padding: 10px;
        text-align: start;
        border: 0.1px solid #FFF;
        width: 320px;
        font-weight: normal;
    `,
    field2: styled.th`
        padding: 10px;
        text-align: start;
        border: 0.1px solid #FFF;
        width: 180px;
        font-weight: normal;
    `,
    td: styled.td`
        padding: 10px;
        text-align: center;
        border: 0.1px solid #FFF;
        select {
            border-radius: 4px;
            padding: 6px 10px;
            border: 1px solid #ccc;
            outline: none;
        }
    `,
    input: styled.input`
        width: 50px;
        height: 30px;
        font-size: 16px;
        padding: 5px;
        border: none;
        border-radius: 5px;
    `,
    totalContainer: styled.div`
        margin-top: 120px; /* Space between the table and total */
        display: flex;
        justify-content: flex-start; /* Align items to the left */
        align-items: center; /* Center vertically */
        padding-left: 20px; /* Add left padding for alignment */
        position: relative; 
    `,
    label: styled.label`
        font-size: 18px;
        margin-right: 10px;
        font-weight: bold; /* Make label bold */
    `,
    sumInput: styled.input`
        width: 80px;
        height: 30px;
        font-size: 16px;
        padding: 5px;
        border: 1px solid #ddd;
        border-radius: 5px;
        text-align: center;
    `,
    selectedSegmentsContainer: styled.div`
        display: flex;
        flex-wrap: wrap;
        margin-top: 10px;
    `,
    segmentTag: styled.div`
        background-color: #add8e6;
        border: 2px solid #add8e6;
        border-radius: 2px;
        padding: 2px 5px; /* Reduced padding for a tighter fit */
        margin: 5px;
        display: inline-flex; /* Change to inline-flex */
        align-items: center;
        font-size: 14px; /* Optional: adjust font size as needed */
    `,
    removeSegment: styled.span`
        margin-left: 8px;
        cursor: pointer;
        color: #ff0000;
        font-weight: bold;
        &:hover {
            cursor: pointer; /* Change cursor to pointer on hover */
        }
    `,
    SubmitButton: styled.button`
        background-color: #007BFF; /* Pretty blue color */
        color: white;
        border: none;
        border-radius: 5px;
        padding: 10px 20px;
        font-size: 16px;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
            background-color: #0056b3; /* Darker blue on hover */
        }

        &:disabled {
            background-color: #d6d6d6;
            cursor: not-allowed;
        }
    `,
    overlay: styled.div`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
        z-index: 999; /* Ensure it sits above other content */
    `,
    confirmationPopup: styled.div`
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 20px;
        background-color: white;
        border: 1px solid #ccc;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        z-index: 1000;
        text-align: center;
        width: 300px; /* Set a width for the popup */
        
        h3 {
            margin-bottom: 15px; /* Spacing for the title */
            font-size: 20px;
            font-weight: bold;
        }

        p {
            margin-bottom: 20px;
            font-size: 16px;
        }

        button {
            margin: 5px;
            background-color: #007BFF; /* Blue color for buttons */
            color: white;
            border: none;
            border-radius: 5px;
            padding: 10px 15px;
            font-size: 16px;
            cursor: pointer;
            transition: background-color 0.3s;

            &:hover {
                background-color: #0056b3; /* Darker blue on hover */
            }
        }
    `,
    profitMarginSection: styled.div`
        width: 100%;
        margin-top: 20px;
        padding: 20px;
        border: 1px solid #ddd;
        border-radius: 8px;
        background-color: #f9f9f9; /* Light background to match existing style */
    `,
    row: styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        font-size: 16px;
        padding: 5px 0;
    `,
    profitLabel: styled.label`
        font-size: 16px;
        font-weight: bold;
    `,
    valueText: styled.span`
        font-size: 16px;
        color: #333; /* Dark grey to match the rest of the app */
    `,
    errorMessage: styled.div`
        color: red; /* Red color to indicate an error */
        font-size: 18px;
        margin-top: 10px; /* Space between the button and error message */
    `,
    headerContainer: styled.div`
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        gap: 10px; /* Space between title and button */
        margin-bottom: 10px;
    `,
};
